import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useParams } from "react-router-dom";
import api from "../../services/api";
import { getWashTypeLabel } from "../../constants/washTypes";

const EarningByPartnerReport = () => {
  const { partnerId, year, month } = useParams();
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchReport = async () => {
      setLoading(true);
      try {
        const response = await api.get(
          `/report/earning-by-partner/${partnerId}/${year}/${month}`
        );
        setReport(response.data);
      } catch (err) {
        setError("Failed to fetch partner wash report.");
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [partnerId, year, month]);

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Washes by Partner - {year}/{month}
      </Typography>

      {loading && (
        <Box sx={{ textAlign: "center", mt: 3 }}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && report.length > 0 && (
        <TableContainer component={Paper} sx={{ mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Booking ID</b>
                </TableCell>
                <TableCell>
                  <b>Customer Name</b>
                </TableCell>
                <TableCell>
                  <b>Vehicle</b>
                </TableCell>
                <TableCell>
                  <b>Wash Type</b>
                </TableCell>
                <TableCell>
                  <b>Seater</b>
                </TableCell>
                <TableCell>
                  <b>Vehicle Number</b>
                </TableCell>
                <TableCell>
                  <b>Earning (₹)</b>
                </TableCell>
                <TableCell>
                  <b>Shared</b>
                </TableCell>
                <TableCell>
                  <b>Completed At</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {report.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.bookingId}</TableCell>
                  <TableCell>{item.customerName}</TableCell>
                  <TableCell>{item.vehicle}</TableCell>
                  <TableCell>
                    {getWashTypeLabel(item.washType)}
                  </TableCell>
                  <TableCell>{item.seater}</TableCell>
                  <TableCell>{item.vehicleNumber}</TableCell>
                  <TableCell>{Math.round(item.earning)}</TableCell>
                  <TableCell>{item.shared ? "Yes" : "No"}</TableCell>
                  <TableCell>
                    {new Date(item.completedAt).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default EarningByPartnerReport;
